import React from "react";
import { ReportExtras } from "@/common/report-configuration";

interface ChartAnnotationsProps {
  reportExtras: ReportExtras;
}

const ChartAnnotations: React.FC<ChartAnnotationsProps> = ({
  reportExtras,
}) => {
  const annotations = [];

  if (reportExtras.attritionRate) {
    annotations.push(
      `Company-wide attrition: ${reportExtras.attritionRate.toLocaleString(
        undefined,
        {
          maximumFractionDigits: 1,
        },
      )}%`,
    );
  }

  if (reportExtras.rollup_hires) {
    annotations.push(
      `Hires in period: ${reportExtras.rollup_hires.toLocaleString()}`,
    );
  }
  if (reportExtras.rollup_terminations) {
    annotations.push(
      `Terminations in period: ${reportExtras.rollup_terminations.toLocaleString()}`,
    );
  }
  if (reportExtras.rollup_promotions) {
    annotations.push(
      `Promotions in period: ${reportExtras.rollup_promotions.toLocaleString()}`,
    );
  }

  return (
    <div className="mb-2 w-full text-right text-sm font-bold text-gray-500">
      {annotations.map((annotation, index) => (
        <div key={index}>{annotation}</div>
      ))}
    </div>
  );
};

export default ChartAnnotations;
